import styled from 'styled-components';
import { spacing } from 'ui/theme/utils';
import { ValidationPattern } from 'helpers/form';

export const TextInput = styled.input.attrs(
  ({ type = 'text', pattern, title, length, ...rest }) => {
    let tooltip;
    if (!pattern) {
      switch (type) {
        case 'text':
          pattern = ValidationPattern.alphanumeric;
          tooltip = 'Only alphanumeric values are accepted';
          break;
        case 'token':
          type = 'text';
          pattern = length ? ValidationPattern.customToken(length) : ValidationPattern.token;
          tooltip = length ? `Please enter a ${length}-digit token` : 'Please enter a valid token';
          break;
        case 'emailOrDot':
          type = 'text';
          pattern = ValidationPattern.emailOrDot;
          tooltip = 'Enter a valid email address or a dot to match any';
          break;
      }
    }

    return {
      type,
      pattern,
      title: title || tooltip,
      ...rest,
    };
  }
)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ boxShadow, variant, theme, noShadow }) => {
    if (noShadow) return 'none';
    switch (variant) {
      case 'minimal':
        if (!boxShadow) boxShadow = 'round';
        break;
      default:
        if (!boxShadow) boxShadow = 'bottom';
        break;
    }

    return theme.shadows[boxShadow] || boxShadow;
  }};
  padding: ${({ variant }) => {
    switch (variant) {
      case 'minimal':
        return '11px';
      default:
        return '11px 11px 14px';
    }
  }};
  border-radius: ${({ borderRadius = '8px' }) => borderRadius};
  border: none;
  width: ${({ width = '100%' }) => width};
  max-width: ${({ maxWidth = '100%' }) => maxWidth};
  text-align: ${({ textAlign = 'left' }) => textAlign};
  letter-spacing: 0.62px;
  color: ${({ theme }) => theme.colors.grey};
  font-weight: 400;
  font-size: 13px;
  ${({ flexGrow }) => flexGrow && `flex-grow: ${flexGrow};`}
  ${({ cursor }) => cursor && `cursor: ${cursor};`}
  ${(props) => spacing(props)}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
